module.exports = __webpack_public_path__ + "img/fadeMarker.4871f02c.svg";